
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  i18nComponentKey: 'WidgetProductReviewsStatistics.components.NoData',
  name: 'NoData',
  props: {
    isTotal: { type: Boolean, default: false },
    userPropertyTypeOptionName: { type: String, default: null }
  },
  computed: {
    ...mapState('widget', ['widget']),
    ...mapState('window', ['windowService']),
    ...mapGetters('session', ['isLoginRequired'])
  },
  methods: {
    ...mapActions('dialog', ['openNewReviewPopup']),
    ...mapActions('widget', ['confirmForLogin']),
    click() {
      this.isLoginRequired ? this.confirmForLogin() : this.openNewReviewPopup();
    }
  }
};
